import script from "./LearningIdentified.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningIdentified.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__